import React from 'react';
import classNames from 'classnames';
import * as styles from './AlgoliaSearch.css';

interface SearchSkeletonProps {
  isNavbarCollapsed?: boolean;
  isDark?: boolean;
}

const SearchSkeleton = ({
  isNavbarCollapsed = false,
  isDark = false
}: SearchSkeletonProps) => {
  const wrapperClass = classNames(styles.searchWrapper, {
    [styles.collapsedSearchWrapper]: isNavbarCollapsed
  });

  const containerClass = classNames(styles.searchForm, {
    [styles.collapsedSearchForm]: isNavbarCollapsed,
    [styles.searchFormDark]: isDark
  });

  const pulseClass = classNames(styles.skeletonPulse, {
    [styles.skeletonPulseDark]: isDark
  });

  return (
    <div className={wrapperClass}>
      <div className={containerClass} aria-hidden="true">
        <div className={`${styles.skeletonIconShape} ${pulseClass}`} />
        <div className={`${styles.skeletonTextShape} ${pulseClass}`} />
      </div>
    </div>
  );
};

export default SearchSkeleton;
